import { useNavigate } from 'react-router-dom';
import { Pencil} from 'lucide-react';

const PassportSection = ({ item, childId, handlePassportModal, handlePassportResultModal }) => {
    const navigate = useNavigate();
	return (
		<>
			{item ? (
                <div
                    onClick={() => {
                        if(item.existPassword) {
                            handlePassportResultModal(childId);
                        } else {
                            alert("인증되지 않은 여권입니다.");
                        }
                    }} 
                    className="cursor-pointer group relative overflow-hidden rounded-[12px] border-2 border-slate-200 hover:border-blue-400 transition-all shadow-sm hover:shadow-md min-h-[190px] md:w-[48%] bg-white flex flex-col">
                    <div className="bg-blue-900 h-6 flex items-center px-4 justify-between shrink-0">
                        <span className="text-[8px] text-blue-200 tracking-[0.1em] font-bold uppercase">AI WORLD</span>
                        <div className="flex gap-1">
                            <div className="w-1.5 h-1.5 rounded-full bg-blue-400 opacity-50" ></div>
                            <div className="w-1.5 h-1.5 rounded-full bg-blue-400 opacity-50" ></div>
                        </div>
                    </div>
                    <div className="px-4 flex-1 flex flex-col justify-center">
                    	<div className="flex space-x-3 mb-1 justify-end absolute top-[35px] right-5">
                            <button
                                className="w-7 h-7 rounded-full bg-white border border-blue-100 shadow-sm hover:bg-blue-50 hover:border-blue-300 flex items-center justify-center transition-all group/edit"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handlePassportModal(childId);
                                }}
                            >
                                <Pencil
                                    size={13}
                                    className="text-blue-500 group-hover/edit:text-blue-700 transition-colors"
                                />
                            </button>
                        </div>
                        <div className="space-y-2">
                            <div className="border-b border-gray-50 pb-1">
                                <p className="text-[9px] text-gray-400 font-bold uppercase leading-none mb-1">Surname / Given Name</p>
                                <p className="font-bold text-lg text-slate-800">{item.name}</p>
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                                <div>
                                    <p className="text-[9px] text-gray-400 font-bold uppercase leading-none mb-1">Passport No.</p>
                                    <p className="font-mono text-[13px] font-bold text-slate-700 tracking-tight">{item.code}</p>
                                </div>
                                <div>
                                    <p className="text-[9px] text-gray-400 font-bold uppercase leading-none mb-1">Grade</p>
                                    <p className="font-bold text-[13px] text-slate-700">{item.grade}학년</p>
                                </div>
                                <div>
                                    <p className="text-[9px] text-gray-400 font-bold uppercase leading-none mb-1">Level</p>
                                    <div className="flex items-center gap-1">
                                        <span className="text-[13px] font-black text-blue-600">LV.</span>
                                        <span className="font-mono text-[13px] font-bold text-slate-700">{item.level}</span>
                                    </div>
                                </div>
                                <div className="flex items-end justify-end">
                                    {item.existPassword ? (
                                        <div className="flex items-center justify-end gap-1 relative group">
                                            <span className="text-[8px] px-1.5 py-0.5 rounded bg-blue-50 text-blue-500 border border-blue-100 font-bold">인증</span>
                                            <div className="relative">
                                                <div className="w-4 h-4 rounded-full border border-gray-300 text-gray-400 text-[10px] flex items-center justify-center cursor-pointer bg-white">
                                                    ?
                                                </div>
                                                <div className="absolute bottom-6 right-0 hidden group-hover:block z-10">
                                                    <div className="bg-gray-900 text-white text-[10px] rounded-md px-2 py-1 whitespace-nowrap shadow-lg">
                                                        인증된 여권입니다.
                                                    </div>
                                                    <div className="absolute top-full right-2 w-2 h-2 bg-gray-900 rotate-45 -mt-1"></div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="flex items-center justify-end gap-1 relative group">
                                            <span className="text-[8px] px-1.5 py-0.5 rounded bg-red-50 text-red-500 border border-red-100 font-bold">미인증</span>
                                            <div className="relative">
                                                <div className="w-4 h-4 rounded-full border border-gray-300 text-gray-400 text-[10px] flex items-center justify-center cursor-pointer bg-white">
                                                    ?
                                                </div>
                                                <div className="absolute bottom-6 right-0 hidden group-hover:block z-10">
                                                    <div className="bg-gray-900 text-white text-[10px] rounded-md px-2 py-1 whitespace-nowrap shadow-lg">
                                                        비밀번호가 설정되지 않은 여권입니다.
                                                    </div>
                                                    <div className="absolute top-full right-2 w-2 h-2 bg-gray-900 rotate-45 -mt-1"></div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    onClick={() => navigate('/passport')} 
                    className="relative overflow-hidden rounded-[12px] border-2 border-gray-200 bg-gray-100 opacity-60 min-h-[190px] md:w-[48%] flex flex-col cursor-pointer">
                    <div className="bg-gray-400 h-6 flex items-center px-4 justify-between shrink-0">
                        <span className="text-[8px] text-gray-200 tracking-[0.1em] font-bold uppercase">
                            AI WORLD
                        </span>

                        <div className="flex gap-1">
                            <div className="w-1.5 h-1.5 rounded-full bg-gray-300 opacity-50"></div>
                            <div className="w-1.5 h-1.5 rounded-full bg-gray-300 opacity-50"></div>
                        </div>
                    </div>

                    <div className="flex-1 flex flex-col items-center justify-center text-center px-4">
                        <div className="flex items-center gap-1 relative group">
                            <p className="text-sm font-bold text-gray-500 mb-1">등록된 여권 없음</p>
                            <div className="relative">
                                <div className="w-4 h-4 rounded-full border border-gray-300 text-gray-400 text-[10px] flex items-center justify-center cursor-pointer bg-white">
                                    ?
                                </div>
                                <div className="absolute bottom-6 right-0 hidden group-hover:block z-10">
                                    <div className="bg-gray-900 text-white text-[10px] rounded-md px-2 py-1 whitespace-nowrap shadow-lg">
                                        여권을 만들고 여행을 시작해보세요!
                                    </div>
                                    <div className="absolute top-full right-2 w-2 h-2 bg-gray-900 rotate-45 -mt-1"></div>
                                </div>
                            </div>
                        </div>
                        <p className="text-xs text-gray-400">
                            연결된 AI 여권이 없습니다.
                        </p>
                    </div>
                </div>
            )}
		</>
	);
}

export default PassportSection;